<template>
  <div class="result">
    <!-- 弹框 -->
    <div class="model" v-if="status">
      <div class="modelContent box_sizing" :class="{ 'hide-scrollbar': obj && obj.topic_type_id == 10 }" style="width: 1000px;">
        <div class="title">评分</div>
        <word ref="word"></word>
        <div class="flex-warp flex_box onebox">
          <div class="one flex_box flex_align_center box_sizing flex-wrap" v-if="obj.content_score && obj.topic_type_id !== 14 && obj.topic_type_id !== 17 && obj.topic_type_id !== 19">
            <div class="neirong flex_box">内容</div>
            <div class="fenshu">
              <div>得分：{{ obj.content_score.score }}分</div>
              <div style="color: #8c9198">
                满分：{{ obj.content_score.full }}分
              </div>
            </div>
          </div>
          <div class="one flex_box flex_align_center box_sizing" v-if="obj.quality_score">
            <div class="neirong flex_box">发音分</div>
            <div class="fenshu">
              <div>得分：{{ obj.quality_score.score }}分</div>
              <div style="color: #8c9198">
                满分：{{ obj.quality_score.full }}分
              </div>
            </div>
          </div>
          <div class="one flex_box flex_align_center box_sizing" v-if="obj.pte_score">
            <div class="neirong flex_box">流利度</div>
            <div class="fenshu">
              <div>得分：{{ obj.pte_score.score }}分</div>
              <div style="color: #8c9198">满分：{{ obj.pte_score.full }}分</div>
            </div>
          </div>
          <div class="one flex_box flex_align_center box_sizing" v-if="obj.format_score">
            <div class="neirong flex_box">格式</div>
            <div class="fenshu">
              <div>得分：{{ obj.format_score.score }}分</div>
              <div style="color: #8c9198">
                满分：{{ obj.format_score.full }}分
              </div>
            </div>
          </div>
          <div class="one flex_box flex_align_center box_sizing" v-if="obj.grammar">
            <div class="neirong flex_box">语法</div>
            <div class="fenshu">
              <div>得分：{{ obj.grammar.score }}分</div>
              <div style="color: #8c9198">满分：{{ obj.grammar.full }}分</div>
            </div>
          </div>
          <div class="one flex_box flex_align_center box_sizing" v-if="obj.wordScore">
            <div class="neirong flex_box">词汇范围</div>
            <div class="fenshu">
              <div>得分：{{ obj.wordScore.score }}分</div>
              <div style="color: #8c9198">满分：{{ obj.wordScore.full }}分</div>
            </div>
          </div>
          <div class="one flex_box flex_align_center box_sizing" v-if="obj.spelling">
            <div class="neirong flex_box">拼写</div>
            <div class="fenshu">
              <div>得分：{{ obj.spelling.score }}分</div>
              <div style="color: #8c9198">满分：{{ obj.spelling.full }}分</div>
            </div>
          </div>
          <div class="one flex_box flex_align_center box_sizing" v-if="obj.structure">
            <div class="neirong flex_box">发展结构</div>
            <div class="fenshu">
              <div>得分：{{ obj.structure.score }}分</div>
              <div style="color: #8c9198">满分：{{ obj.structure.full }}分</div>
            </div>
          </div>
          <!-- <div class="one flex_box flex_align_center box_sizing" v-if="obj.structure">
            <div class="neirong flex_box">语言范围</div>
            <div class="fenshu">
              <div>得分：{{ obj.structure.score }}分</div>
              <div style="color: #8c9198">满分：{{ obj.structure.full }}分</div>
            </div>
          </div> -->
          <div
            v-if="obj.total"
            class="one flex_box flex_align_center box_sizing"
          >
            <div class="neirong flex_box">总分</div>
            <div class="fenshu">
              <div>得分：{{ obj.total.score }}分</div>
              <div style="color: #8c9198">满分：{{ obj.total.full }}分</div>
            </div>
          </div>
        </div>
        <div class="zuoda box_sizing" v-if="obj.topic_type_id==8||obj.topic_type_id==9">
          <div class="zuodatitle box_sizing">作答内容</div>
          <div class="zuodacont">{{ obj.content }}</div>
          <div class="zuodatitle box_sizing">正确答案</div>
          <div class="zuodacont">{{ obj.daan }}</div>
        </div>
        <div class="zuoda box_sizing" v-if="obj.topic_type_id==10">
          <div class="zuodatitle box_sizing">作答内容</div>
          <div class="ro-answer-section">
            <div v-for="(item, index) in getAnswerContentArray(obj.content, obj.extend_sort)" :key="index" class="ro-answer-item">
              <span class="ro-answer-index">【{{ index + 1 }}】</span>
              <span class="ro-answer-text">{{ item ? item : "空" }}</span>
            </div>
          </div>
          <div class="zuodatitle box_sizing" style="margin-top: 16px;">正确答案</div>
          <div class="ro-answer-section">
            <div v-for="(item, index) in getCorrectAnswerArray(obj.daan)" :key="index" class="ro-answer-item">
              <span class="ro-answer-index">【{{ index + 1 }}】</span>
              <span class="ro-answer-text">{{ getAnswerContent(item, obj.extend_sort) }}</span>
            </div>
          </div>
        </div>
        <div class="zuoda box_sizing" v-if="obj.topic_type_id==11||obj.topic_type_id==12||obj.topic_type_id==15">
          <div class="zuodatitle box_sizing">作答内容</div>
          <div class="ro-answer-section">
            <div v-for="(item, index) in getFibUserAnswerList(obj)" :key="index" class="ro-answer-item">
              <span class="ro-answer-index">【{{ index + 1 }}】</span>
              <span class="ro-answer-text">{{ item }}</span>
            </div>
          </div>
          <div class="zuodatitle box_sizing" style="margin-top: 16px;">正确答案</div>
          <div class="ro-answer-section">
            <div v-for="(item, index) in getFibCorrectAnswerList(obj)" :key="index" class="ro-answer-item">
              <span class="ro-answer-index">【{{ index + 1 }}】</span>
              <span class="ro-answer-text">{{ item }}</span>
            </div>
          </div>
        </div>
        <div class="zuoda box_sizing" v-if="obj.topic_type_id==14||obj.topic_type_id==16||obj.topic_type_id==17||obj.topic_type_id==18">
          <div class="zuodatitle box_sizing">作答内容</div>
          <div class="zuodacont">{{ obj.content }}</div>
          <div class="zuodatitle box_sizing">正确答案</div>
          <div class="zuodacont">{{ obj.daan }}</div>
        </div>
        <!-- <div class="zuoda box_sizing" v-if="obj.topic_type_id==19">
          <div class="zuodatitle box_sizing">作答内容</div>
          <div class="hiw-answer-section">
            <span 
              v-for="(word, index) in (obj.content_arr || (obj.total && obj.total.content) || [])" 
              :key="index"
              class="hiw-word"
              :class="isHIWWordCorrect(word, obj.return_obj || (obj.total && obj.total.return) || {}) ? 'hiw-correct' : 'hiw-wrong'"
            >{{ word }}</span>
          </div>
          <div class="zuodatitle box_sizing" style="margin-top: 16px;">正确答案</div>
          <div class="hiw-answer-section">
            <span 
              v-for="(word, index) in getHIWUserAnswerList(obj.daan)" 
              :key="index"
              class="hiw-word hiw-correct"
            >{{ word }}</span>
          </div>
        </div> -->
        <div class="zuoda box_sizing" v-if="obj.topic_type_id == 20">
          <div class="">
            <div class="words-top">
              <div class="tag">
                <div class="color-block-success"></div>
                <div>正确</div>
              </div>
              <div class="tag">
                <div class="color-block-omit"></div>
                <div>漏词</div>
              </div>
              <div class="tag">
                <div class="color-block-error"></div>
                <div>非答案</div>
              </div>
            </div>
            <div class="words">
              <div v-for="(item, index) in obj.word_state_arr" :key="index">
                <div
                  class="text"
                  :class="[
                    item.state == 0
                      ? (item.word == ',' || item.word == '.' ? 'error cancel_margin' : 'error')
                      : item.state == 1
                      ? (item.word == ',' || item.word == '.' ? 'success cancel_margin' : 'success')
                      : (item.word == ',' || item.word == '.' ? 'omit cancel_margin' : 'omit'),
                  ]"
                >
                  {{ item.word }}
                </div>
              </div>
            </div>
            <div class="words-answer">答案</div>
            <div class="words" v-html="wfdAnswerHtml"></div>
          </div>
        </div>
        <div class="zuoda box_sizing" v-if="obj.topic_type_id==6||obj.topic_type_id==7||obj.topic_type_id==13">
          <div class="zuodatitle box_sizing">作答内容</div>
          <div class="zuodacont" style="height: auto !important;" v-html="obj.content"></div>
        </div>
        <div class="zuoda" style="font-size: 16px;" v-if="obj.word_data != null">
          <div>{{obj.word_data}}</div>
        </div>
        <div class="zuoda box_sizing" v-if="obj.topic_type_id < 6">
          <div class="zuodatitle box_sizing">作答内容</div>
          <mp3-tool v-if="obj.qiniu_url" ref="mp3" :src-url="obj.qiniu_url+obj.content" @showDuration="getDuration"></mp3-tool>
          <div v-else v-html="obj.content"></div>
        </div>
        <div class="zuoda box_sizing" v-if="obj.qiniu_url">
          <div class="zuodatitle box_sizing">AI识别</div>
          <div class="ai_box">
            <div class="ai_level_type">
              <div class="ai_level_type_color goodcolor"></div>
              <div>Good</div>
            </div>
            <div class="ai_level_type">
              <div class="ai_level_type_color badcolor"></div>
              <div>Bad</div>
            </div>
            <div class="ai_level_type">
              <div class="ai_level_type_color averagecolor"></div>
              <div>Average</div>
            </div>
          </div>
          <div class="clickable_html" v-html="aiResultHtml" @click="onWordClick"></div>
        </div>

        <div class="cancel" @click="status = false">
          <img src="../assets/images/login_close.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Mp3Tool from "@/components/mp3Tool.vue";
import Word from "@/components/word.vue";
export default {
    components: {
      Mp3Tool,
      Word
    },
  name: "result",
  data() {
    return {
      status: false,
      obj: {}
    };
  },

  computed: {
    /**
     * AI 识别结果富文本（支持点击查词）。
     * @returns {string} 处理后的 HTML
     */
    aiResultHtml() {
      return this.wrapWordsInHtml((this.obj && this.obj.ai_result) || "");
    },
    wfdAnswerHtml() {
      return this.ensureAnswerSpacing((this.obj && this.obj.answer) || "");
    },
  },

  watch: {
    obj: {
      /**
       * 监听评分对象变化：针对 MCM 多选题统一修正为"选对项计分"，针对 FIB 类题型修正总分
       * @param {Object} val - 新的评分对象
       * @returns {void} 无返回值，必要时会触发 this.obj 的二次赋值
       */
      handler(val) {
        if (!val || val.__scoreFixed) {
          return;
        }
        if (val.topic_type_id === 9 || val.topic_type_id === 14 || val.topic_type_id === 17) {
          this.obj = this.fixMcmScore(val);
        }
        if (val.topic_type_id === 11 || val.topic_type_id === 12 || val.topic_type_id === 15) {
          this.obj = this.fixFibScore(val);
        }
        if (val.topic_type_id === 10) {
          this.obj = this.fixROScore(val);
        }
        if (val.topic_type_id === 19) {
          this.obj = this.fixHIWScore(val);
        }
      },
      deep: false,
      immediate: true
    }
  },

  methods: {
    /**
     * 处理富文本容器的点击事件（事件代理）。
     * 点击到被包裹的单词 span 时触发查词。
     * @param {MouseEvent} e 点击事件
     * @returns {void}
     */
    onWordClick(e) {
      const target = e && e.target;
      if (!target || !target.dataset) return;
      const word = target.dataset.word;
      if (!word) return;
      this.dianjiClick(word);
    },

    /**
     * 在保留原 HTML 标签结构/样式的前提下，将文本节点中的英文单词包裹为可点击 span。
     * - 保留 <br> 与常见块级标签的换行语义
     * - 忽略 script/style 等节点
     * @param {string} html 原始富文本 HTML
     * @returns {string} 处理后的 HTML
     */
    wrapWordsInHtml(html) {
      const raw = String(html || "");
      const withNewlines = raw
        .replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n")
        .replace(/<br\s*\/?>/gi, "<br/>")
        .replace(/<\/(p|div|li|tr|h[1-6])\s*>/gi, "</$1><br/>");

      const root = document.createElement("div");
      root.innerHTML = withNewlines;

      const wordRe = /[A-Za-z]+(?:[-'][A-Za-z]+)*/g;
      const wrapTextNode = (textNode) => {
        const text = textNode.nodeValue || "";
        if (!text) return;
        const frag = document.createDocumentFragment();
        let lastIndex = 0;
        let match;
        while ((match = wordRe.exec(text)) !== null) {
          const start = match.index;
          const end = start + match[0].length;
          if (start > lastIndex) {
            frag.appendChild(document.createTextNode(text.slice(lastIndex, start)));
          }
          const span = document.createElement("span");
          span.className = "click_word";
          span.dataset.word = match[0];
          span.textContent = match[0];
          frag.appendChild(span);
          lastIndex = end;
        }
        if (lastIndex < text.length) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex)));
        }
        textNode.parentNode && textNode.parentNode.replaceChild(frag, textNode);
      };

      const walk = (node) => {
        if (!node) return;
        if (node.nodeType === Node.ELEMENT_NODE) {
          const tag = (node.tagName || "").toLowerCase();
          if (tag === "script" || tag === "style") return;
          if (tag === "span" && node.dataset && node.dataset.word) return;
          const children = Array.from(node.childNodes);
          children.forEach(walk);
        } else if (node.nodeType === Node.TEXT_NODE) {
          wrapTextNode(node);
        }
      };

      walk(root);
      return root.innerHTML;
    },

    ensureAnswerSpacing(html) {
      const raw = String(html || "");
      if (!raw) {
        return "";
      }

      const root = document.createElement("div");
      root.innerHTML = raw;

      const isWordChar = (char) => /[A-Za-z0-9]/.test(char);
      const isPunctuation = (char) => /[.,!?;:)]/.test(char);

      const getTextValue = (node) => {
        if (!node) return "";
        return (node.textContent || "").replace(/\u00a0/g, " ").trim();
      };

      const shouldInsertSpace = (prevNode, nextNode) => {
        const prevText = getTextValue(prevNode);
        const nextText = getTextValue(nextNode);
        if (!prevText || !nextText) {
          return false;
        }

        const prevChar = prevText.slice(-1);
        const nextChar = nextText.charAt(0);

        return isWordChar(prevChar) && isWordChar(nextChar) && !isPunctuation(nextChar);
      };

      const processNode = (node) => {
        if (!node || !node.childNodes || node.childNodes.length < 2) {
          return;
        }

        const children = Array.from(node.childNodes);
        children.forEach((child) => {
          if (child.nodeType === Node.ELEMENT_NODE) {
            processNode(child);
          }
        });

        for (let index = children.length - 2; index >= 0; index -= 1) {
          const current = children[index];
          const next = children[index + 1];
          if (shouldInsertSpace(current, next)) {
            node.insertBefore(document.createTextNode(" "), next);
          }
        }
      };

      processNode(root);
      return root.innerHTML;
    },

    /**
     * 点击单词触发查词弹窗。
     * @param {string} item 单词
     * @returns {void}
     */
    dianjiClick(item) {
      if (!item || item == '&nbsp;' || item == '<br/>') {return;}
      this.$refs.word.word_text = item;
      this.$refs.word.getWord();
    },
    /**
     * 接收音频组件回传的时长
     * @param {Number} time - 音频时长（秒）
     * @returns {void} 无返回值，用于更新组件内部 timeLen
     */
    getDuration(time) {
      this.timeLen = time;
    },

    /**
     * 规范化多选题选项字符串
     * @param {String} value - 原始选项字符串（如 "B,C,F"）
     * @returns {String[]} 选项数组（去重、去空、统一大写）
     */
    normalizeChoiceString(value) {
      if (!value || typeof value !== 'string') {
        return [];
      }
      const parts = value
        .split(/[,，;；\s]+/)
        .map((v) => String(v).trim().toUpperCase())
        .filter((v) => v);
      return Array.from(new Set(parts));
    },

    /**
     * 计算多选题得分：只统计“选中且正确”的数量（交集大小），不做负分抵消
     * @param {String} userContent - 用户作答内容
     * @param {String} correctAnswer - 正确答案
     * @returns {{score: number, full: number}} 计算出的得分与满分
     */
    calcMcmScore(userContent, correctAnswer) {
      const userChoices = this.normalizeChoiceString(userContent);
      const correctChoices = this.normalizeChoiceString(correctAnswer);
      const correctSet = new Set(correctChoices);
      const score = userChoices.reduce((acc, c) => acc + (correctSet.has(c) ? 1 : 0), 0);
      return {
        score,
        full: correctChoices.length
      };
    },

    /**
     * 修复 MCM 多选题得分对象：将 total/content_score/score/full 调整为“选对项计分”
     * @param {Object} obj - 评分对象
     * @returns {Object} 修复后的评分对象（浅拷贝）
     */
    fixMcmScore(obj) {
      const { score, full } = this.calcMcmScore(obj.content, obj.daan);
      const next = { ...obj, __scoreFixed: true };

      if (next.total && typeof next.total === 'object') {
        next.total = { ...next.total, score, full };
      } else {
        next.total = { score, full };
      }

      if (next.content_score && typeof next.content_score === 'object') {
        next.content_score = { ...next.content_score, score, full };
      } else {
        next.content_score = { score, full };
      }

      if (typeof next.score === 'number') {
        next.score = score;
      }
      if (typeof next.full === 'number') {
        next.full = full;
      }

      return next;
    },

    /**
     * 计算 RO 题型得分：两个连续选项相同才得分
     * @param {String|Array} userContent - 用户作答内容
     * @param {String|Array} correctAnswer - 正确答案
     * @returns {{score: number, full: number}} 计算出的得分与满分
     */
    calcROScore(userContent, correctAnswer) {
      // 将答案转换为数组
      const userArr = this.normalizeROAnswer(userContent);
      const correctArr = this.normalizeROAnswer(correctAnswer);
      
      if (correctArr.length < 2) {
        return { score: 0, full: 0 };
      }
      
      // 满分 = 选项数 - 1（相邻对的数量）
      const full = correctArr.length - 1;
      
      // 构建正确答案的相邻对集合
      const correctPairs = new Set();
      for (let i = 0; i < correctArr.length - 1; i++) {
        correctPairs.add(`${correctArr[i]},${correctArr[i + 1]}`);
      }
      
      // 计算用户答案中正确的相邻对数量
      let score = 0;
      for (let i = 0; i < userArr.length - 1; i++) {
        const pair = `${userArr[i]},${userArr[i + 1]}`;
        if (correctPairs.has(pair)) {
          score++;
        }
      }
      
      return { score, full };
    },

    /**
     * 规范化 RO 题型答案为数组
     * @param {String|Array} answer - 原始答案
     * @returns {String[]} 答案数组
     */
    normalizeROAnswer(answer) {
      if (!answer) {
        return [];
      }
      if (Array.isArray(answer)) {
        return answer.map(item => String(item).trim()).filter(item => item);
      }
      if (typeof answer === 'string') {
        return answer.split(/[,，;；\s]+/).map(item => item.trim()).filter(item => item);
      }
      return [];
    },

    /**
     * 修复 RO 题型得分对象：使用连续配对计分规则
     * @param {Object} obj - 评分对象
     * @returns {Object} 修复后的评分对象（浅拷贝）
     */
    fixROScore(obj) {
      const { score, full } = this.calcROScore(obj.content, obj.daan);
      const next = { ...obj, __scoreFixed: true };

      if (next.total && typeof next.total === 'object') {
        next.total = { ...next.total, score, full };
      } else {
        next.total = { score, full };
      }

      if (next.content_score && typeof next.content_score === 'object') {
        next.content_score = { ...next.content_score, score, full };
      } else {
        next.content_score = { score, full };
      }

      if (typeof next.score === 'number') {
        next.score = score;
      }
      if (typeof next.full === 'number') {
        next.full = full;
      }

      return next;
    },

    /**
     * 修复 FIB 类题型得分对象：确保总分的满分值等于所有空位数（包括未作答的）
     * @param {Object} obj - 评分对象
     * @returns {Object} 修复后的评分对象（浅拷贝）
     */
    fixFibScore(obj) {
      const next = { ...obj, __scoreFixed: true };
      
      // 获取正确答案列表，确定总空位数
      const correctAnswers = this.getFibCorrectAnswerList(next);
      const totalBlanks = correctAnswers.length;
      
      if (totalBlanks === 0) {
        return next;
      }
      
      // 计算用户得分：遍历每个空位，比较用户答案与正确答案
      let score = 0;
      if (next.content && typeof next.content === 'object' && !Array.isArray(next.content)) {
        correctAnswers.forEach((correctAnswer) => {
          const userAnswer = next.content[correctAnswer];
          if (userAnswer !== undefined && userAnswer !== null && String(userAnswer) === String(correctAnswer)) {
            score++;
          }
        });
      }
      
      // 修正 total 对象的 full 值为总空位数
      if (next.total && typeof next.total === 'object') {
        next.total = { ...next.total, full: totalBlanks };
      } else {
        next.total = { score, full: totalBlanks };
      }
      
      // 修正 content_score 对象的 full 值
      if (next.content_score && typeof next.content_score === 'object') {
        next.content_score = { ...next.content_score, full: totalBlanks };
      }
      
      // 修正顶层 full 值
      if (typeof next.full === 'number') {
        next.full = totalBlanks;
      }
      
      return next;
    },

    /**
     * 获取 FIB 类题型的正确答案列表（按空位顺序，确保未作答空位也能显示）
     * @param {Object} obj - 评分对象（期望包含 fib_correct_answers 或 content）
     * @returns {String[]} 正确答案数组
     */
    getFibCorrectAnswerList(obj) {
      if (!obj) {
        return [];
      }
      if (Array.isArray(obj.fib_correct_answers) && obj.fib_correct_answers.length > 0) {
        return obj.fib_correct_answers;
      }
      if (obj.content && typeof obj.content === 'object' && !Array.isArray(obj.content)) {
        return Object.keys(obj.content);
      }
      return [];
    },

    /**
     * 获取 FIB 类题型的作答列表（按空位顺序，与正确答案列表对齐，未作答留空）
     * @param {Object} obj - 评分对象（期望包含 content 与 fib_correct_answers）
     * @returns {String[]} 作答数组
     */
    getFibUserAnswerList(obj) {
      const correctList = this.getFibCorrectAnswerList(obj);
      if (!obj || !obj.content || typeof obj.content !== 'object' || Array.isArray(obj.content)) {
        return correctList.map(() => '');
      }
      return correctList.map((answerKey) => {
        const val = obj.content[answerKey];
        if (val === undefined || val === null) {
          return '';
        }
        return String(val);
      });
    },
    // 将正确答案转换为数组格式
    getCorrectAnswerArray(daan) {
      if (!daan) {
        return [];
      }
      if (Array.isArray(daan)) {
        return daan;
      }
      if (typeof daan === 'string') {
        // 尝试用逗号、分号或空格分隔
        return daan.split(/[,，;；\s]+/).filter(item => item.trim());
      }
      return [];
    },
    // 根据答案编号获取对应的 content 内容
    getAnswerContent(answerIndex, extend_sort) {
      if (!answerIndex || !extend_sort || !Array.isArray(extend_sort)) {
        return answerIndex || "空";
      }
      // 尝试多种匹配方式
      let item = null;
      // 1. 通过 show_index 匹配（show_index 可能是字符串或数字）
      item = extend_sort.find(sortItem => String(sortItem.show_index) === String(answerIndex));
      // 2. 如果没找到，通过数组索引匹配（答案可能是从1开始的索引）
      if (!item && !isNaN(answerIndex)) {
        const index = parseInt(answerIndex) - 1; // 转换为0基索引
        if (index >= 0 && index < extend_sort.length) {
          item = extend_sort[index];
        }
      }
      // 3. 如果还没找到，尝试直接通过 index 字段匹配
      if (!item) {
        item = extend_sort.find(sortItem => String(sortItem.index) === String(answerIndex));
      }
      if (item && item.content) {
        return item.content;
      }
      return answerIndex || "空";
    },
    // 将作答内容转换为数组格式，并显示对应的 content
    getAnswerContentArray(content, extend_sort) {
      if (!content) {
        return [];
      }
      let contentArray = [];
      // 如果 content 是数组，直接使用
      if (Array.isArray(content)) {
        contentArray = content;
      } else if (typeof content === 'string') {
        // 如果是字符串，尝试分隔
        contentArray = content.split(/[,，;；\s]+/).filter(item => item.trim());
      } else if (typeof content === 'object') {
        // 如果是对象，转换为数组（保持顺序）
        contentArray = Object.values(content);
      }
      // 如果有 extend_sort，将索引转换为对应的 content
      if (extend_sort && Array.isArray(extend_sort) && extend_sort.length > 0) {
        return contentArray.map(item => {
          return this.getAnswerContent(item, extend_sort);
        });
      }
      return contentArray;
    },

    /**
     * 计算 HIW 题型得分：content 数组中的单词如果在 return 字段的 key 中，则得 1 分
     * @param {Array} contentArr - score.content 数组
     * @param {Object} returnObj - score.return 对象
     * @param {String|Array} correctAnswer - 正确答案
     * @returns {{score: number, full: number}} 计算出的得分与满分
     */
    calcHIWScore(contentArr, returnObj, correctAnswer) {
      const correctArr = this.getHIWUserAnswerList(correctAnswer);
      
      if (correctArr.length === 0) {
        return { score: 0, full: 0 };
      }
      
      const full = correctArr.length;
      
      // 如果没有 content 数组或 return 对象，返回 0 分
      if (!Array.isArray(contentArr) || !returnObj || typeof returnObj !== 'object') {
        return { score: 0, full };
      }
      
      // 获取 return 对象的所有 key
      const returnKeys = Object.keys(returnObj).map(key => key.toLowerCase());
      
      // 遍历 content 数组，检查是否在 return 的 key 中
      let score = 0;
      contentArr.forEach(word => {
        if (word && returnKeys.includes(String(word).toLowerCase())) {
          score++;
        }
      });
      
      return { score, full };
    },

    /**
     * 修复 HIW 题型得分对象
     * @param {Object} obj - 评分对象（包含 content 数组和 return 对象）
     * @returns {Object} 修复后的评分对象
     */
    fixHIWScore(obj) {
      const contentArr = obj.content_arr || (obj.total && obj.total.content) || [];
      const returnObj = obj.return_obj || (obj.total && obj.total.return) || {};
      const { score, full } = this.calcHIWScore(contentArr, returnObj, obj.daan);
      const next = { ...obj, __scoreFixed: true };

      if (next.total && typeof next.total === 'object') {
        next.total = { ...next.total, score, full };
      } else {
        next.total = { score, full };
      }

      if (next.content_score && typeof next.content_score === 'object') {
        next.content_score = { ...next.content_score, score, full };
      } else {
        next.content_score = { score, full };
      }

      if (typeof next.score === 'number') {
        next.score = score;
      }
      if (typeof next.full === 'number') {
        next.full = full;
      }

      return next;
    },

    /**
     * 获取 HIW 用户答案列表
     * @param {String|Array} answer - 答案
     * @returns {String[]} 答案数组
     */
    getHIWUserAnswerList(answer) {
      if (!answer) {
        return [];
      }
      if (Array.isArray(answer)) {
        return answer.map(item => String(item).trim()).filter(item => item);
      }
      if (typeof answer === 'string') {
        return answer.split(/[,，;；\s]+/).map(item => item.trim()).filter(item => item);
      }
      return [];
    },

    /**
     * 检查 HIW 单词是否正确（在 return 对象的 key 中）
     * @param {String} word - 用户选择的单词
     * @param {Object} returnObj - score.return 对象
     * @returns {Boolean} 是否正确
     */
    isHIWWordCorrect(word, returnObj) {
      if (!returnObj || typeof returnObj !== 'object') {
        return false;
      }
      const returnKeys = Object.keys(returnObj).map(key => key.toLowerCase());
      return returnKeys.includes(String(word).toLowerCase());
    },
  },
};
</script>
<style>
/* 弹框最大高度限制和滚动支持 */
.modelContent {
  max-height: 85vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.clickable_html {
  line-height: 1.8;
  word-break: break-word;
}

.click_word {
  cursor: pointer;
}

.click_word:hover {
  text-decoration: underline;
}

 .modelContent.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
 }

 .modelContent.hide-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
 }

/* RO题型答案内容样式优化 */
.ro-answer-section {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 12px;
  background: #fafafa;
  text-align: left;
}

 .ro-answer-section {
  -ms-overflow-style: none;
  scrollbar-width: none;
 }

 .ro-answer-section::-webkit-scrollbar {
  width: 0;
  height: 0;
 }

.ro-answer-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 22px;
}

.ro-answer-item:last-child {
  margin-bottom: 0;
}

.ro-answer-index {
  color: #f6704b;
  font-weight: 600;
  flex-shrink: 0;
  margin-right: 4px;
}

.ro-answer-text {
  color: #333;
  word-break: break-word;
}

.words-top {
  display: flex;
  justify-content: space-around;
  font-size: 15px;
  color: #666667;
  margin-top: 15px;
  margin-bottom: 10px;
}

.tag {
  display: flex;
  align-items: center;
}
.color-block-error {
  background: #666667;
  border-radius: 100%;
  width: 15px;
  height: 15px;
  margin-right: 12px;
}

.color-block-success {
  background: #85d88d;
  border-radius: 100%;
  width: 15px;
  height: 15px;
  margin-right: 12px;
}

.color-block-omit {
  background: #dd786e;
  border-radius: 100%;
  width: 15px;
  height: 15px;
  margin-right: 12px;
}
.words {
  display: flex;
  flex-wrap: wrap;
  margin-top: 40rpx;
}

.words .text {
  margin-right: 10rpx;
  word-wrap: break-word;
}

.error {
  margin-right: 3px;
  color: #666667;
  text-decoration: line-through;
}

.success {
  margin-right: 3px;

  color: #85d88d;
}

.omit {
  margin-right: 3px;

  color: #dd786e;
}
.cancel_margin {
  margin-left: -3px;
}
.words-answer {
  margin-top: 25px;
  margin-bottom: 10px;
  font-size: 16px;
}
.one {
  width: 55%;
}
.zuoda {
  font-size: 16px;
}
.zuodacont {
  width: auto !important;
  height: auto !important;
}

/* HIW题型答案样式 */
.hiw-answer-section {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #eee;
}

.hiw-word {
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
}

.hiw-correct {
  background: rgba(18, 211, 191, 0.15);
  color: #12d3bf;
  border: 1px solid #12d3bf;
}

.hiw-wrong {
  background: rgba(246, 112, 75, 0.15);
  color: #f6704b;
  border: 1px solid #f6704b;
}
</style>
